import { sets } from '@/configs/translates.config';

export default {
	'add-new-set': `Add new ${sets.en.singular}`,
	set: sets.en.singular,
	'the-set': `the ${sets.en.singular}?`
}